import React, { useCallback, useState } from "react"
import { ChangeLanguageComponent } from "components/shared/ModalHelpers"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { ProfileService } from "services/api-service"
import { SentryService } from "services/SentryService"
import Button from "ui/components/atoms/button"
import Input from "ui/components/atoms/input"
import Alert from "ui/components/molecules/alert"
import Modal from "ui/components/molecules/modal"
import { EMAIL_REGEX } from "ui/utils/regex"

const ChangePassword = () => {
  const navigate = useNavigate()
  const { t } = useTranslation(["panel", "form", "common", "data"])
  const dispatch = useDispatch()
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      newpassword: "",
      newpassword2: "",
    },
  })

  const [loading, setLoading] = useState(false)
  const [error, setErrorPassword] = useState(false)

  const handleProfile = useCallback(() => {
    navigate("/panel")
  }, [navigate])

  const onSubmit = useCallback(
    async (el: any) => {
      if (el.newpassword !== el.newpassword2) {
        setError(
          "newpassword2",
          {
            type: "custom",
            message: t("profile.password.different"),
          },
          {
            shouldFocus: true,
          },
        )
        return
      }

      try {
        setLoading(true)
        setErrorPassword(false)
        await ProfileService.updatePassword(el.newpassword)
        reset()
        handleProfile()
      } catch (e) {
        SentryService.error("[ERROR ProfileService.updatePassword]:", e)
        setErrorPassword(true)
        return
      } finally {
        setLoading(false)
      }
    },
    [handleProfile, reset, setError, t],
  )

  return (
    <Modal
      show={true}
      icon="shield"
      title={t("profile.password.title")}
      text={t("profile.password.text")}
      $maxWidth="400px"
      showBackground={false}
    >
      <>
        {error && (
          <Alert $type="error" $small $marginBottom="S">
            {t("profile.password.error")}
          </Alert>
        )}
        <Input
          name="newpassword"
          label={t("profile.password.new-password")}
          type="password"
          error={errors.newpassword}
          rhf={register("newpassword", {
            required: t("required", { ns: "form" }),
            pattern: {
              value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
              message: t("wrong-password", { ns: "form" }),
            },
          })}
          $marginBottom="S"
        />
        <Input
          name="newpassword2"
          label={t("profile.password.new-password-2")}
          type="password"
          error={errors.newpassword2}
          rhf={register("newpassword2", {
            required: t("required", { ns: "form" }),
            pattern: {
              value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
              message: t("wrong-password", { ns: "form" }),
            },
          })}
          $marginBottom="S"
        />
        <Button $width="100%" loading={loading} icon="save" onClick={handleSubmit(onSubmit)}>
          {t("save", { ns: "common" })}
        </Button>
        <Button $type="third" $width="100%" onClick={handleProfile}>
          {t("back", { ns: "common" })}
        </Button>
      </>
    </Modal>
  )
}

export default ChangePassword
